import React from "react";

import { StyledNavItem } from "./styles";
import { NavItemProps } from "./types";

/**
 * Componente NavItem
 *
 * Representa um item de navegação interativo.
 *
 * @param {string} label - Texto exibido no item.
 * @param {() => void} action - Callback executado ao clicar no item.
 * @param {boolean} [uppercase=false] - Transforma o texto em maiúsculas se `true`.
 */
export const NavItem: React.FC<NavItemProps> = ({
  label,
  action,
  uppercase = false,
}) => {
  return (
    <StyledNavItem onClick={action} role="menuitem" uppercase={uppercase}>
      {label}
    </StyledNavItem>
  );
};
